export const zIndex = {
  toolbar: 5,
  sidebar: 10,
  modal: 12,
}